import {restoreSupplierFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierFunctionKeys, supplierFunctionMutationKeys} from "../../../supplierFunction-keys";

export function restoreSupplierFunctionMutationOptions() {
  return mutationOptions({
    mutationFn: (supplierFunctionId: string) => restoreSupplierFunction(supplierFunctionId),
    mutationKey: supplierFunctionMutationKeys.restoreSupplierFunction,
    onSuccess: async (_data, supplierFunctionId, _context, {client}) => {
      client.removeQueries({queryKey: supplierFunctionKeys.detail(supplierFunctionId)});
      await client.invalidateQueries({queryKey: supplierFunctionKeys.lists()});
    },
  });
}
